import client from "api/config";
import { convertNum } from "helper/convert-num";

//////////////////// records ////////////////////
const recordsUrl = "records";
// get all records data
export const getRecordsDataRequest = (values) =>
  client.get(`
${recordsUrl}?
skip=${values.skip ?? 0}&limit=${values.limit ?? 10}
  ${values.search ? "&search=" + convertNum(values.search) : ""}
`);

// add record
export const addRecordRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  values.title && formData.append("title", values.title);
  values.text && formData.append("text", values.text);
  formData.append("show_in_home_page", values.show_in_home_page);
  values.category_id && formData.append("category_id", values.category_id);
  !values.main_image.isWeb &&
    formData.append("main_image", values.main_image.url);
  !values.video.isWeb && formData.append("video", values.video.url);
  return client.post(`admin/${recordsUrl}`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

// update record
export const updateRecordRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  values.title && formData.append("title", values.title);
  values.text && formData.append("text", values.text);
  formData.append("show_in_home_page", values.show_in_home_page);
  values.category_id && formData.append("category_id", values.category_id);
  !values.main_image.isWeb &&
    formData.append("main_image", values.main_image.url);
  !values.video.isWeb && formData.append("video", values.video.url);
  return client.post(`admin/${recordsUrl}/${values.id}?_method=put`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

// get record by id
export const getRecordByIdRequest = (values) => {
  return client.get(`${recordsUrl}/${values.id}`);
};
// delete record by id
export const deleteRecordByIdRequest = (id) =>
  client.delete(`admin/${recordsUrl}/${id}`);

/////// Records subcategory ///////
const recordSubCategoryUrl = "/record_categories";
// get all records subcategory
export const getRecordSubCategoryRequest = (values) =>
  client.get(`${recordSubCategoryUrl}?
  skip=${values.skip ?? 0}&limit=${values.limit ?? 10}`);

// get records subcategory by id
export const getRecordSubcategoryByIdRequest = (values) =>
  client.get(`${recordSubCategoryUrl}/${values.id}`);

// add records subcategory
export const addRecordSubCategoryRequest = (values) =>
  client.post(`/admin${recordSubCategoryUrl}`, values);

// edit records subcategory
export const editRecordSubCategoryRequest = (values) =>
  client.post(`/admin${recordSubCategoryUrl}/${values.id}?_method=put`, values);
// delete records subcategory
export const deleteRecordSubCategoryByIdRequest = (id) =>
  client.delete(`admin${recordSubCategoryUrl}/${id}`);
